type RowData = {
  [key: string]: any;
  nrc_o_fai_val?: number;
  nrc_o_me_val?: number;
  nrc_o_av_val?: number;
  nrp_o_fai_val?: number;
  nrp_o_me_val?: number;
  nrp_o_av_val?: number;
  prog_mgt_fee?: number;
  exchange_rate?: number;
  nrp_c_value?: number;
  npi_htz?: string;
  htz?: string;
};
type UpdateRowProps = {
  rowId: string;
  updatedFields: { [key: string]: number };
};

type CalculateOpexValuesProps = {
  rowId?: string;
  row: RowData;
  updateRow?: (props: UpdateRowProps) => void;
  changedCol?: string;
  value?: number;
  allRows?: RowData[];
};
const parseNumber = (value: any, defaultValue: number = 0): number => {
  const parsed = Number(value);
  return isNaN(parsed) ? defaultValue : parsed;
};
export const CalculateOpexValues = (props: CalculateOpexValuesProps) => {
  const { rowId, row, updateRow, changedCol, value } = props;

  const faiVal = parseNumber(row.nrc_o_fai_val);
  const nrcVal = parseNumber(row.nrc_o_me_val);
  const nrcAv = parseNumber(row.nrc_o_av_val);
  const nrpFai = parseNumber(row.nrp_o_fai_val);
  const nrpMe = parseNumber(row.nrp_o_me_val);
  const nrpAv = parseNumber(row.nrp_o_av_val);
  const nrcOFaiVal = changedCol === 'nrc_o_fai_val' ? parseNumber(value) : faiVal;
  const nrcOMeVal = changedCol === 'nrc_o_me_val' ? parseNumber(value) : nrcVal;
  const nrcOAvVal = changedCol === 'nrc_o_av_val' ? parseNumber(value) : nrcAv;
  const nrpOFaiVal = changedCol === 'nrp_o_fai_val' ? parseNumber(value) : nrpFai;
  const nrpOMeVal = changedCol === 'nrp_o_me_val' ? parseNumber(value) : nrpMe;
  const nrpOAvVal = changedCol === 'nrp_o_av_val' ? parseNumber(value) : nrpAv;

  const progMgtFee = parseNumber(row.prog_mgt_fee);
  const exchangeRate = parseNumber(row.exchange_rate);
  const nrpCValue = parseNumber(row.nrp_c_value);

  const nrpOProgManVal = ((nrpOFaiVal + nrpOMeVal + nrpOAvVal) * progMgtFee) / 100;
  const nrcOProgManVal = ((nrcOFaiVal + nrcOMeVal + nrcOAvVal) * progMgtFee) / 100;

  const nrpOBuyIpaVal = (nrcOFaiVal + nrcOMeVal + nrcOAvVal + nrpCValue) * exchangeRate;

  const nrpOTotalVal = nrpOProgManVal + nrpOFaiVal + nrpOMeVal + nrpOAvVal;
  const nrcOTotalVal = nrcOProgManVal + nrcOFaiVal + nrcOMeVal + nrcOAvVal;
  const updatedFields = {
    nrp_o_buy_ipa_val: nrpOBuyIpaVal,
    nrp_o_total_val: nrpOTotalVal,
    nrc_o_total_val: nrcOTotalVal,
    nrp_o_prog_man_val: nrpOProgManVal,
    nrc_o_prog_man_val: nrcOProgManVal,
  };

  if (updateRow && rowId) {
    updateRow({
      rowId,
      updatedFields,
    });
  }

  return updatedFields;
};
